import { render, staticRenderFns } from "./ProductsSection.vue?vue&type=template&id=5c0f6870&scoped=true"
import script from "./ProductsSection.vue?vue&type=script&lang=js"
export * from "./ProductsSection.vue?vue&type=script&lang=js"
import style0 from "./ProductsSection.vue?vue&type=style&index=0&id=5c0f6870&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0f6870",
  null
  
)

export default component.exports